/**
 * apiBase — single source of truth for the backend origin used by frontend
 * fetches.
 *
 * Defaults to same-origin in the browser, but can be overridden at build time
 * for split frontend/API deploys such as Railway-backed `api.tacostreet.co`.
 *
 * History: this used to read process.env.REACT_APP_BACKEND_URL from the
 * Emergent platform's deploy-time /app/frontend/.env. Stale builds shipped
 * with that var pointing at a preview host (e.g. preview-main-11.emergent.host),
 * so every fetch went to a dead URL after the production domain changed.
 * Same-origin remains the safe fallback when no explicit API base is provided.
 */
const configuredApiBase = (process.env.REACT_APP_API_BASE_URL || "").trim().replace(/\/+$/, "");

export const API_BASE: string =
  configuredApiBase || (typeof window !== 'undefined' ? window.location.origin : '');
